import React from "react";

export const CertifIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none">
      <path
        d="M14.5998 19.8108L21.2105 13.2001L20.2585 12.2495L14.5998 17.9081L11.7492 15.0561L10.7972 16.0081L14.5998 19.8108ZM15.9998 27.9468C13.3216 27.1521 11.0963 25.5299 9.32384 23.0801C7.55139 20.6303 6.66562 17.8703 6.6665 14.8001V7.58945L15.9998 4.10278L25.3332 7.58945V14.8001C25.3332 17.8703 24.4474 20.6303 22.6758 23.0801C20.9043 25.5299 18.6789 27.1535 15.9998 27.9508M15.9998 26.5348C18.3109 25.8014 20.2221 24.3348 21.7332 22.1348C23.2443 19.9348 23.9998 17.4903 23.9998 14.8015V8.50012L15.9998 5.52678L7.99984 8.50012V14.8001C7.99984 17.489 8.75539 19.9335 10.2665 22.1335C11.7776 24.3335 13.6887 25.8014 15.9998 26.5348Z"
        fill="#ABCDEC"
      />
    </svg>
  );
};
